<template>
  <div class="login-wrapper">
    <!-- 最底层背景图 -->
    <div class="login-bg-wrapper">
      <img src="@/assets/login_bg.jpg" alt="">
    </div>
    <!-- 黑色透明覆盖层 -->
    <div class="bg-cover"></div>
    <!-- 中央登录主体 -->
    <normalLogin/>
    <!-- 登录页脚 -->
    <div class="login-footer">
      <span v-html="copy_info"></span>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import normalLogin from './components/normalLogin'
export default {
  name: 'login',
  components:{
    normalLogin,
  },
  data(){
    return {
      copy_info:'Copyright &copy; 2019 Florina 费罗娜 保留所有权利',
    }
  },
  methods:{
    ...mapActions({
      login:'user/login'
      
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/custom-variables.scss';
.login-wrapper{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #333;
  .login-bg-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      filter: blur(8px);
    }
  }
  .bg-cover{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    z-index: 2;
  }
  .login-footer{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #c5c1c1;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    z-index: 3;
  }
}
</style>
<style lang="scss">
.login-wrapper{

  
}
</style>


